import { createFileRoute } from "@tanstack/react-router";
import { DiscoveryPage } from "@/components/DiscoveryPage";
import { discoverySearchSchema } from "@/lib/discovery-search";

export const Route = createFileRoute("/properties/")({
  validateSearch: discoverySearchSchema,
  component: () => <DiscoveryPage initialView="properties" />,
});
